import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { queryOptions } from '@tanstack/angular-query-experimental';
import { firstValueFrom } from 'rxjs';

import { DocumentationPage } from '../types/documentation';

const APP_DOCUMENTATION_BASE_URL = 'https://budgets.money/api/app-docs/v1';

@Injectable({ providedIn: 'root' })
export class DocumentationService {
  private http = inject(HttpClient);

  documentationPageQueryOptions(slug: string) {
    return queryOptions({
      queryKey: ['documentation', 'page', slug] as const,
      queryFn: () => this.fetchDocumentationPage(slug),
    });
  }

  private fetchDocumentationPage(slug: string): Promise<DocumentationPage> {
    return firstValueFrom(this.http.get<DocumentationPage>(this.documentationPageUrl(slug)));
  }

  private documentationPageUrl(slug: string): string {
    const encodedSlug = encodeURIComponent(slug);
    return `${APP_DOCUMENTATION_BASE_URL}/${encodedSlug}.json`;
  }
}
